import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { "render-html": "true" }

import { computed } from 'vue';
import PaginatedResponse from '@/core/http/PaginatedResponse';
import AppButton from '@/core/components/form/AppButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourcePagination',
  props: {
    response: {}
  },
  emits: [
	'navigate',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const itemsTotal = computed(() => props.response.itemsTotal);
const pageStart = computed(() => props.response.pageStart);
const pageEnd = computed(() => props.response.pageEnd);

const navigate = (cursor: string) => emit('navigate', cursor);
const pages = computed(() => {
	const pages = [props.response.createCursor(1)];
	let minPage: number;
	let maxPage: number;

	// Maximum of 5 pages in between first and last page
	if (props.response.pages > 2) {
		minPage = Math.max(2, props.response.currentPage - 2);
		maxPage = Math.min(props.response.currentPage + 2, props.response.pages - 1);

		for (let i = minPage; i <= maxPage; i++) {
			pages.push(props.response.createCursor(i));
		}
	}

	// Link to last page should always be there (if more than 1 page)
	if (props.response.pages > 1) {
		pages.push(props.response.createCursor(props.response.pages));
	}

	if (pages.length > 1) {
		return pages;
	}

	return [];
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (__props.response.previousUrl)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (navigate(__props.response.previousUrl)), ["prevent"])),
            icon: "chevron-left",
            seamless: true,
            small: ""
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
        return (_openBlock(), _createBlock(AppButton, {
          key: page.page,
          onClick: _withModifiers(($event: any) => (navigate(page.cursor)), ["prevent"]),
          class: _normalizeClass({current: page.page === __props.response.currentPage}),
          seamless: true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page.page), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "class"]))
      }), 128)),
      (__props.response.nextUrl)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (navigate(__props.response.nextUrl)), ["prevent"])),
            icon: "chevron-right",
            seamless: true,
            small: ""
          }))
        : _createCommentVNode("", true)
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
      _createTextVNode(" Visar %{ pre }%{ pageStart } - %{ pageEnd }%{ post } av %{ itemsTotal } ", -1)
    ]))])), [
      [_directive_translate, {
				pageStart: pageStart.value,
				pageEnd: pageEnd.value,
				itemsTotal: itemsTotal.value,
				pre: '<strong>',
				post: '</strong>',
			}]
    ])
  ]))
}
}

})